<template>
<v-card flat>
  <v-card-title class='grey lighten-4' >
    <v-text-field
      label='Search for a medical aid'
      v-model='searchString'
      prepend-icon='search'
      clearable
      hint='Start typing the name of a medical aid' >
    </v-text-field>
  </v-card-title>
  <v-divider></v-divider>
  <v-card-text>
    <!-- <pre>{{filteredResults}}</pre> -->
    <v-list dense>
      <v-subheader v-if='filteredQuickPick && filteredQuickPick.length > 0' >Quick pick</v-subheader>
      <template v-for='(medicalaid,index) in filteredQuickPick' >
        <v-list-tile :key='`li-${medicalaid.email}-${index}`' @click='select(medicalaid)' >
          <v-list-tile-content>
            <v-list-tile-title>{{medicalaid.name}}</v-list-tile-title>
            <v-list-tile-sub-title>{{medicalaid.email}}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider :key='`div-${medicalaid.email}-${index}`' ></v-divider>
      </template>
      <v-subheader>All medical aids</v-subheader>
      <template v-for='(medicalaid, index) in filteredResults' >
        <v-list-tile :key='index' @click='select(medicalaid)' >
          <v-list-tile-content>
            <v-list-tile-title>{{medicalaid.name}}</v-list-tile-title>
            <v-list-tile-sub-title>{{medicalaid.email}}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider :key='`${index}-div`' ></v-divider>
      </template>
      <v-list-tile v-if='filteredResults.length === 0' >
        <v-list-tile-content>
          <v-list-tile-title>Your search returned no results.
          <v-btn @click='searchString=""' small flat>Try again?</v-btn>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-card-text>
</v-card>
</template>
<script>
export default {
  name: 'MedicalAidPicker',
  props: {
    value: { type: Object, default: () => { return null } }
  },
  methods: {
    select (medicalaid) {
      this.$emit('input', medicalaid)
    }
  },
  computed: {
    filteredQuickPick () {
      if (this.searchString && this.searchString.length > 1) {
        return this.quickpicks.filter((item) => {
          return (item.name.toLowerCase().indexOf(this.searchString.toLowerCase()) !== -1)
        })
      }
      return this.quickpicks
    },
    filteredResults () {
      if (this.searchString && this.searchString.length > 1) {
        return this.medicalaids.filter((item) => {
          return (item.name.toLowerCase().indexOf(this.searchString.toLowerCase()) !== -1)
        })
      }
      return this.medicalaids
    }
  },
  data () {
    return {
      searchString: null,
      quickpicks: [
        {name: 'DISCOVERY Health Medical Scheme', email: 'claims@discovery.co.za'},
        {name: 'BONITAS Medical Fund', email: 'claims@bonitas.co.za'},
        {name: 'COMPCare WELLNESS Medical Scheme', email: 'claims@universal.co.za'},
        {name: 'PROFMED', email: 'claims@profmed.co.za'}
      ],
      medicalaids: [
        {name: 'AECI Medical Aid Society', email: 'claims@medscheme.co.za'},
        {name: 'ANGLO Medical Scheme', email: 'claims@angloms.co.za'},
        {name: 'ANGLOVAAL Group Medical Scheme', email: 'claims@discovery.co.za'},
        {name: 'BANKMED', email: 'claims@bankmed.co.za'},
        {name: 'BARLOWORLD Medical Scheme', email: 'claims@medscheme.co.za'},
        {name: 'BESTMED Medical Scheme', email: 'claims@bestmed.co.za'},
        {name: 'BMW EMPLOYEES Medical Aid Society', email: 'claims@discovery.co.za'},
        {name: 'BONITAS Medical Fund', email: 'claims@bonitas.co.za'},
        {name: 'BP Medical Aid Society', email: 'bpmas@mhg.co.za'},
        {name: 'BUILDING & CONSTRUCTION INDUSTRY Medical Aid Fund', email: 'anne.gildenhuys@universal.co.za'},
        {name: 'CAPE Medical Plan', email: 'mail@cmp.co.za'},
        {name: 'CHARTERED ACCOUNTANTS (SA) Medical Aid Fund (CAMAF)', email: 'claims@camaf.co.za'},
        {name: 'COMMUNITY Medical Aid Scheme (COMMED)', email: 'Under liquidation'},
        {name: 'COMPCare WELLNESS Medical Scheme', email: 'claims@universal.co.za'},
        {name: 'DE BEERS BENEFIT Society', email: 'benefitpost@dbbs.co.za'},
        {name: 'DISCOVERY Health Medical Scheme', email: 'claims@discovery.co.za'},
        {name: 'ENGEN Medical BENEFIT Fund', email: 'engenaccounts@mhg.co.za'},
        {name: 'FEDHealth Medical Scheme', email: 'claims@fedhealth.co.za'},
        {name: 'FISHING INDUSTRY Medical Scheme (FISH-MED)', email: 'fishingindustry@mhg.co.za'},
        {name: 'GENESIS Medical Scheme', email: 'claims@genesismedical.co.za'},
        {name: 'GLENCORE Medical Scheme', email: 'medicalscheme.claims@glencore.co.za'},
        {name: 'GOVERNMENT EMPLOYEES Medical Scheme (GEMS)', email: 'enquiries@gems.gov.za'},
        {name: 'Health Squared', email: 'claims@healthsquared.co.za'},
        {name: 'HORIZON Medical Scheme', email: 'claims@medscheme.co.za'},
        {name: 'HOSMED Medical Aid Scheme', email: 'enquiries@hosmed.co.za'},
        {name: 'IMPERIAL MOTUS MED', email: 'claims@imperialmotusmed.co.za'},
        {name: 'KEYHealth', email: 'general@keyhealthmedical.co.za'},
        {name: 'LA-Health Medical Scheme', email: 'claims@discovery.co.za'},
        {name: 'LIBCare Medical Scheme', email: 'claims@libcare.co.za '},
        {name: 'MALCOR Medical Scheme', email: 'claims@malcormedicalaid.co.za'},
        {name: 'MASSMART Health Plan', email: 'massmart@universal.co.za'},
        {name: 'MBMED Medical Aid Fund', email: 'claims@medscheme.co.za'},
        {name: 'MEDIHELP', email: 'claims@medihelp.co.za'},
        {name: 'MEDSHIELD Medical Scheme', email: 'member@medshield.co.za'},
        {name: 'MOMENTUM Health', email: 'claims@momentumhealth.co.za'},
        {name: 'MOTO Health Medical', email: 'claims@mhcmf.co.za'},
        {name: 'NASPERS Medical Fund', email: 'claims@discovery.co.za'},
        {name: 'NEDGroup Medical Aid Scheme', email: 'nedgroup.newclaims@medscheme.co.za '},
        {name: 'NETCare Medical Scheme', email: 'claims@netcaremedicalscheme.co.za'},
        {name: 'OLD MUTUAL STAFF Medical Aid Fund (OMSMAF)', email: 'claims@OMSMAF.co.za'},
        {name: 'PG Group Medical Scheme', email: 'claims@pggmeds.co.za'},
        {name: 'PLATINUM Health', email: 'zzgplatinumhealthclaims@platinumhealth.co.za'},
        {name: 'PROFMED', email: 'claims@profmed.co.za'},
        {name: 'REMEDI Medical Aid Scheme', email: 'claims@discovery.co.za'},
        {name: 'RESOLUTION Health Medical Scheme', email: 'clientservices@resomed.co.za'},
        {name: 'RHODES UNIVERSITY Medical Scheme', email: 'rumedclaims@providence.co.za'},
        {name: 'SABC Medical Aid Scheme', email: 'claims@medscheme.co.za'},
        {name: 'SASOLMED', email: 'claims@sasolmed.co.za'},
        {name: 'SASOLMED Weight Management Programme', email: 'weightmanagement@sasolmed.co.za'},
        {name: 'SISONKE Health Medical Scheme', email: 'sh-ms@providence.co.za'},
        {name: 'Sizwe queries', email: 'queries@sizwe.co.za'},
        {name: 'Sizwe escalations', email: 'escalations@sizwemedfund.co.za'},
        {name: 'SizweHosmed', email: 'claims@sizwehosmed.co.za'},
        {name: 'SOUTH AFRICAN BREWERIES Medical Scheme', email: 'claims@sabmas.co.za'},
        {name: 'SOUTH AFRICAN POLICE SERVICE Medical Scheme (POLMED)', email: 'polmedcurrentclaims@medscheme.co.za'},
        {name: 'SPECTRAMED', email: 'claims@spectramed.co.za'},
        {name: 'TEST', email: 'christo@appointmentguru.co'},
        {name: 'TFG Medical Aid Scheme', email: 'claims@discovery.co.za'},
        {name: 'TIGER BRANDS Medical Scheme', email: 'admin@universal.co.za'},
        {name: 'TRANSMED Medical Fund', email: 'claims@transmed.co.za'},
        {name: 'UNIVERSITY OF KWA-ZULU NATAL Medical Scheme', email: 'claims@discovery.co.za'},
        {name: 'UNIVERSITY OF THE WITWATERSRAND - JOHANNESBURG STAFF Medical Aid Fund', email: 'claims@witsmed.co.za'},
        {name: 'Witbank Coalfields Medical Aid Scheme (WCMAS)', email: 'wcmas@wcmas.co.za'},
        {name: 'Midmed Alliance', email: 'service@alliancemidmed.co.za'}
      ]
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// MedicalAidPicker.vue?0f8b97fe